import { render, staticRenderFns } from "./usage-record-info.vue?vue&type=template&id=80fe46c6&"
import script from "./usage-record-info.vue?vue&type=script&lang=js&"
export * from "./usage-record-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80fe46c6')) {
      api.createRecord('80fe46c6', component.options)
    } else {
      api.reload('80fe46c6', component.options)
    }
    module.hot.accept("./usage-record-info.vue?vue&type=template&id=80fe46c6&", function () {
      api.rerender('80fe46c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/usage-record/usage-record-info.vue"
export default component.exports